import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Radio from '../Radio';
import * as styles from './RadioGroup.scss';

/**
 * @class RadioGroup
 * @classdesc Reusable RadioGroup Component
 * @property {Object} state
 * @example ./RadioGroup.md
 */
export default class RadioGroup extends Component {
  static propTypes = {
    buttons: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.oneOfType([
          PropTypes.number,
          PropTypes.string,
        ]).isRequired,
        className: PropTypes.string,
        style: PropTypes.objectOf(
          PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string,
          ]),
        ),
        text: PropTypes.string,
        wrapperClassName: PropTypes.string,
      }),
    ).isRequired,
    defaultSelection: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
    ]).isRequired,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string,
    orientation: PropTypes.string,
    reset: PropTypes.bool,
  };

  static defaultProps = {
    className: null,
    orientation: 'column',
    reset: false,
  };

  constructor(props) {
    super(props);
    const { defaultSelection } = this.props;

    this.state = {
      currentSelection: defaultSelection,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.defaultSelection !== prevState.currentSelection && nextProps.reset) {
      return { currentSelection: nextProps.defaultSelection };
    }
    return null;
  }

  /**
   * onChange Handler to Call onChange Callback Using Radio Name
   * @return onChange
   */
  changeHandler = e => {
    const { onChange } = this.props;
    return onChange(e.target.name);
  };

  /**
   * Tracks Current Radio Selection Inside Form
   * @return setState - Updates `currentSelection` Property
   */
  handleCurrentSelection = value => {
    return this.setState({ currentSelection: value });
  };

  /**
   * Renders Radio Components
   * @return {ReactElement}
   */
  renderRadios = () => {
    const { buttons, orientation } = this.props;
    const { currentSelection } = this.state;
    const style = orientation === 'row'
      ? { marginRight: '16px' }
      : { marginTop: '12px' };

    return buttons.map(btn => {
      return (
        <div key={btn.value} className={styles.radioRow} style={style}>
          <Radio
            key={btn.value}
            className={btn.className}
            selected={btn.value === currentSelection}
            onChange={this.handleCurrentSelection}
            text={btn.text}
            name={btn.value}
            style={btn.style}
            wrapperClassName={btn.wrapperClassName}
            disabled={btn.disabled}
            radioGroup
          />
          {btn.renderChildren && btn.renderChildren()}
        </div>
      );
    });
  };

  render() {
    const { className } = this.props;

    return (
      <form className={className} onChange={this.changeHandler}>
        {this.renderRadios()}
      </form>
    );
  }
}
